import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import SelectWithSearch from "@/features/shared/components/SelectWithSearch/SelectWithSearch";
import useCities from "@/features/city/hooks/useCities";
const CitySelector = ({ onSelect, initialValue }) => {
    const { cities } = useCities(undefined, undefined, true);
    const [selectedCity, setSelectedCity] = useState({ value: 0, label: "" });
    useEffect(() => {
        if (initialValue?.id) {
            setSelectedCity({
                value: initialValue.id,
                label: initialValue.label?.trim() || "",
            });
        }
    }, [initialValue]);
    const cityOptions = cities.map((c) => ({
        value: c.id ?? 0,
        label: c.label?.trim() || "",
    }));
    const handleCitySelect = (option) => {
        const selected = cities.find((c) => c.id === option.value);
        if (selected) {
            setSelectedCity({ value: selected.id ?? 0, label: selected.label?.trim() || "" });
            onSelect(selected);
        }
    };
    return (_jsx(SelectWithSearch, { label: "Ville", options: cityOptions, selectedItem: selectedCity, onSelect: handleCitySelect }));
};
export default CitySelector;
